<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle">{{ $t("settings.taxes") }}</h2>

    <div class="columns">
      <div
        class="column is-narrow"
        v-if="this.storeBeingManaged.address.countryCode === 'PT'"
      >
        <b-field :label="`% ${$t('settings.defaultVAT')}`">
          <b-select
            v-model="storeBeingManaged.taxes.defaultVAT"
            @focus="saveCurrentVAT"
            @input="setDefaultVAT"
          >
            <option value="23">23%</option>
            <option value="13">13%</option>
            <option value="6">6%</option>
            <option value="0">0%</option>
          </b-select>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      currentVAT: 0
    };
  },

  computed: {
    ...mapGetters(["storeBeingManaged"])
  },

  methods: {
    setDefaultVAT() {
      if (this.storeBeingManaged.taxes.defaultVAT !== this.currentVAT) {
        this.isLoading = true;
        this.$store
          .dispatch("setDefaultVAT", {
            storeId: this.storeBeingManaged._id,
            defaultVAT: this.storeBeingManaged.taxes.defaultVAT
          })
          .then(res => {
            if (res.data.result === "ok") {
              this.$buefy.toast.open({
                message: this.$t("settings.defaultVATUpdated"),
                type: "is-success",
                position: "is-bottom",
                duration: 5000
              });
            } else {
              this.alertError(res.data);
            }
          })
          .catch(() => {
            this.alertError({ message: "UNEXPECTED_ERROR" });
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    saveCurrentVAT() {
      this.currentVAT = this.storeBeingManaged.taxes.defaultVAT;
    }
  },

  mounted() {
    if (!this.storeBeingManaged.taxes.defaultVAT) {
      this.storeBeingManaged.taxes.defaultVAT = 23;
      this.setDefaultVAT();
    }
    this.saveCurrentVAT();
  }
};
</script>

<style scoped>
.option-switch {
  position: relative;
  top: 2px;
}
</style>
